import client from './client';
import type { StorageLocation } from '@/types/api';

export const storageLocationsApi = {
  getAll: async (): Promise<StorageLocation[]> => {
    const res = await client.get('/storage-locations');
    return res.data;
  },

  getTree: async (): Promise<StorageLocation[]> => {
    const res = await client.get('/storage-locations/tree');
    return res.data;
  },

  getById: async (id: string): Promise<StorageLocation> => {
    const res = await client.get(`/storage-locations/${id}`);
    return res.data;
  },

  create: async (data: {
    name: string;
    description?: string;
    locationType: string;
    parentId?: string | null;
    sortOrder?: number;
  }): Promise<StorageLocation> => {
    const res = await client.post('/storage-locations', data);
    return res.data;
  },

  update: async (id: string, data: {
    name?: string;
    description?: string;
    locationType?: string;
    parentId?: string | null;
    sortOrder?: number;
  }): Promise<StorageLocation> => {
    const res = await client.put(`/storage-locations/${id}`, data);
    return res.data;
  },

  delete: async (id: string): Promise<void> => {
    await client.delete(`/storage-locations/${id}`);
  },
};
